export default "__VITE_ASSET__DXD_lfkS__"